import React from 'react';
import PropTypes from 'prop-types';

/**
 * GlassCard - A card component with glass-like styling
 */
const GlassCard = ({ 
  children, 
  className = '', 
  variant = 'light',
  border = true,
  hover = false,
  ...props 
}) => {
  // Base styles
  const baseStyles = 'rounded-lg transition-all duration-200 p-6';
  
  // Variant styles
  const variantStyles = {
    light: 'bg-white text-black',
    dark: 'bg-black text-white',
    primary: 'bg-primary-500 text-black',
    secondary: 'bg-secondary-500 text-white'};
  
  // Hover effects
  const hoverStyles = hover ? 'hover:shadow-lg hover:translate-y-[-2px]' : '';
  
  // Border styles
  const borderStyles = border ? 'border border-gray-200' : '';

  // 3D shadow styles based on variant
  const shadowColor = variant === 'dark' ? 'rgba(255, 255, 255, 0.8)' : 'rgba(0, 0, 0, 0.8)';
  const shadowStyle = {
    boxShadow: `3px 3px 0 ${shadowColor}`,
    transform: 'translateX(-3px) translateY(-3px)'
  };

  return (
    <div 
      className={`${baseStyles} ${variantStyles[variant]} ${hoverStyles} ${borderStyles} ${className}`}
      style={shadowStyle}
      {...props}
    >
      {children}
    </div>
  );
};

GlassCard.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['light', 'dark', 'primary', 'secondary']),
  border: PropTypes.bool,
  hover: PropTypes.bool};

export default GlassCard;
